export default __webpack_public_path__ + "static/media/LogoMandeSeguro.8240fe3c.svg";